import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Globals } from 'app/services/globals'
import { Tag } from 'app/models/tag';
import { FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { tap, finalize, map } from 'rxjs/operators';
import { UserService } from './user.service';
import { FilesRetentionSettings } from 'app/models/files-retention-settings';

@Injectable({ providedIn: 'root' })
export class SettingsService {
    constructor(private http: HttpClient, private globals: Globals,
            private userService: UserService) { 
    }

    // MFA Required
    getIsMFARequired() {
        return this.http.get<any>(`${this.globals.api_base_url}/settings/mfa_required`).pipe(map((t) => {
            return <boolean>(t.state);
        }));
    }

    postIsMFARequired(newState: boolean) {
        return this.http.post<any>(`${this.globals.api_base_url}/settings/mfa_required`, {
            state: newState
        });
    }

    // Files Retention
    getFilesRetention() {
        return this.http.get<FilesRetentionSettings>(`${this.globals.api_base_url}/settings/files_retention`);
    }

    postFilesRetention(retention: FilesRetentionSettings) {
        return this.http.post<any>(`${this.globals.api_base_url}/settings/files_retention`, retention);
    }
}